import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { FormControl, FormHelperText, InputLabel, useTheme } from '@material-ui/core';

import TemplateContent from './TemplateContent';
import { TemplateSelectorDialog } from 'routes/Dashboard/Template';
import { call, classes } from 'utils';

import styles from './TemplateInput.module.scss';

const TemplateInput = props => {
  const [dialog, setDialog] = useState();
  const theme = useTheme();

  const { name, error, value = {} } = props;

  const helperText =
    (typeof props.helperText === 'string'
      ? props.helperText
      : (props.helperText || {}).templateId) || ' ';

  useEffect(() => {
    if (dialog === false) {
      call(props.onBlur, { target: { name } });
    }
  }, [name, dialog]);

  return (
    <div className={styles.input}>
      <FormControl required={props.required} fullWidth={props.fullWidth} error={error}>
        <InputLabel htmlFor={name} shrink={!!value.templateId}>
          {props.label}
        </InputLabel>

        <div
          className={classes(styles.content, error ? styles.error : '')}
          style={error ? { borderColor: theme.palette.error.main } : undefined}
          onClick={() => setDialog(true)}
        >
          <TemplateContent data={value} />
        </div>

        <FormHelperText error>{error && helperText ? helperText : ' '}</FormHelperText>
      </FormControl>

      <TemplateSelectorDialog
        open={!!dialog}
        onClose={() => setDialog(false)}
        onChange={data => {
          setDialog(false);

          call(props.onChange, {
            type: 'change',
            target: {
              name,
              value: {
                templateId: data._id,
                icon: data.iconUrl || '',
                name: _.get(data, 'params.category') || '',
                type: data.type,
                title: data.name,
              },
            },
          });
        }}
      />
    </div>
  );
};

export default TemplateInput;
